import { CtrlBaseComponent } from '../controls';
import { TokenResponseModel } from './TokenResponseModel';
export class AppState {
    public loggedUser: TokenResponseModel;
    public currenView: any;
    public userRoles: string[];
}